import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Logo: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.729 9.098c.478 2.336.332 4.77-.506 6.982-.824 2.174-2.357 3.86-4.119 5.22-1.828 1.41-3.853 2.476-6.088 2.656-2.469.198-4.947-.257-7.095-1.596-2.433-1.518-4.988-3.455-5.727-6.4-.739-2.948.787-5.905 1.945-8.69C3.229 4.648 4.25 1.637 6.65.428c2.324-1.17 4.927.384 7.457.812 2.209.373 4.6.068 6.389 1.528 1.818 1.486 2.737 3.915 3.232 6.33z"
        fill="#6A9BFC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.32 15.615c-.601 2.085-1.738 3.938-3.33 5.27-1.564 1.31-3.485 1.882-5.45 2.08-2.04.208-4.09.044-5.934-.925-2.037-1.07-3.808-2.662-4.945-4.789C1.37 14.841.162 12.04.814 9.344c.653-2.7 3.101-4.28 5.186-5.906C7.963 1.907 10.037.034 12.443.271c2.33.229 3.738 2.752 5.562 4.349 1.59 1.393 3.612 2.34 4.414 4.384.816 2.078.524 4.456-.098 6.611z"
        fill="#0441BC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.74 12.745c-.069 1.769-.6 3.477-1.585 4.883-.968 1.381-2.355 2.266-3.849 2.87-1.55.627-3.18.967-4.803.63-1.793-.373-3.478-1.214-4.773-2.618-1.467-1.591-2.948-3.508-2.957-5.765-.01-2.26 1.596-4.055 2.909-5.803 1.236-1.646 2.493-3.584 4.414-3.947 1.86-.353 3.442 1.3 5.17 2.133 1.507.727 3.264 1.007 4.282 2.423 1.035 1.44 1.263 3.366 1.192 5.194z"
        fill="#002369"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.884 13.228a3.03 3.03 0 001.048-1.039 2.94 2.94 0 00.423-1.522V8.689a.19.19 0 01.191-.189h.908a.19.19 0 01.191.189v1.978c0 .556.155 1.076.423 1.522.257.426.617.784 1.048 1.04l1.788 1.016a.187.187 0 01.07.257l-.453.774a.193.193 0 01-.262.069l-1.758-.999a3.06 3.06 0 00-1.501-.39 3.06 3.06 0 00-1.502.39l-1.757.999a.193.193 0 01-.262-.07l-.453-.773a.187.187 0 01.07-.258l1.788-1.016z"
        fill="#fff"
      />
    </svg>
  );
};

export default Logo;
